export async function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const img = new Image()
      img.onload = () => resolve(img)
      img.onerror = reject
      img.src = reader.result as string
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export function makeImageSquare(img: HTMLImageElement): HTMLCanvasElement {
  const size = Math.max(img.width, img.height)
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const context = canvas.getContext('2d')!
  context.drawImage(img, (size - img.width) / 2, (size - img.height) / 2)
  return canvas
}

export async function canvasToFile(canvas: HTMLCanvasElement, fileName: string, fileType: string): Promise<File> {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      resolve(new File([blob!], fileName, { type: fileType }))
    }, fileType)
  })
}
